export default Object.freeze({
    School: 1,
    Teacher: 2,
    Student: 3,    
  });    